import { Alert } from "@mui/material";
import styled from "styled-components";

import { Button } from "components/atoms/Button";
import { device } from "utils/sizes";
import { colourScheme } from "utils/styling/colours";
import { Label, Small, Text } from "utils/styling/typography.styled";

export const SessionRecorderContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2rem;
    width: 100%;
    max-width: 100vw;
    padding: 2rem;
    background-color: ${colourScheme.primary};
    border-radius: 1rem;
    color: white;
`;

export const TwoColumnLayout = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    gap: 2rem;
    width: 100%;
    max-width: 100vw;

    ${device.md} {
        grid-template-columns: 1fr 1fr;
    }
`;

export const SessionNameContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding: 1rem;
    border: 1px solid ${colourScheme.primaryLight};
    border-radius: 0.5rem;
    background-color: ${colourScheme.primaryDark};
    gap: 0.5rem;
    align-items: center;
`;

export const SessionLabel = styled(Label)`
    margin-bottom: 1rem;
`;

export const CostDisplay = styled.div`
    border: 1px solid ${colourScheme.primaryLight};
    background-color: ${colourScheme.primaryDark};
    padding: 1rem;
    border-radius: 0.5rem;
    color: ${colourScheme.white};
    text-align: center;
`;

export const RecordButton = styled(Button)<{ isRecording: boolean }>`
    background-color: ${({ isRecording }) =>
        isRecording ? colourScheme.error : colourScheme.success};
    color: white;
    border-radius: 0.5rem;
    width: 100%;
    max-width: 250px;
    font-size: 1.2rem;
`;

export const ShareLinkBox = styled.div`
    border: 1px solid ${colourScheme.primaryLight};
    background-color: ${colourScheme.primaryDark};
    padding: 1rem;
    border-radius: 0.5rem;
    margin-top: 1rem; /* Adds space above the share link box */
`;

export const ShareLinkContainer = styled.div`
    text-align: center;
    margin-top: 1.5rem;
`;

export const ShareText = styled(Text)`
    color: ${colourScheme.white};
`;

export const ShareLink = styled.div`
    border: 1px solid ${colourScheme.primaryLight};
    background-color: ${colourScheme.primary};
    padding: 0.5rem 1rem;
    border-radius: 0.5rem;
    word-break: break-all;
    margin-bottom: 0.5rem;
    color: ${colourScheme.greyLight};
`;

export const CostPerMinuteDisplay = styled.div`
    border: 1px solid ${colourScheme.primaryLight};
    background-color: ${colourScheme.primaryDark};
    padding: 1rem;
    border-radius: 0.5rem;
    color: ${colourScheme.white};
    text-align: center;
`;

export const CostNote = styled(Small)`
    font-size: 0.9rem;
    color: ${colourScheme.grey};
`;

export const TerminationAlert = styled(Alert)`
    width: 100%;
    max-width: 600px;
    text-align: center;
    margin-bottom: 1rem;
`;

export const TopUpButton = styled(Button)`
    margin-top: 1rem;
`;

export const ImageViewerContainer = styled.div<{ $hasImages: boolean }>`
    display: ${({ $hasImages }) => ($hasImages ? "block" : "none")};
    width: 100%;
`;

export const SessionInfoText = styled(Text)`
    color: ${colourScheme.white};
    font-size: 1.2rem;
    margin: 1rem 0;
`;
